import { styled } from '@mui/material/styles';
import { COLOR } from '@src/styles/color';

export const StyledNoData = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
  padding: 0px;
  height: ${(props) => props.height || '100%'};
  justify-content: center;

  .no-data-text {
    color: ${COLOR.label2[64]};
    font-size: 14px;
    font-weight: 400;
  }
`;
